import React from 'react';

import {
  HOUSEKEEPING_STATUS_TO_COLOR_MAPPER,
  HOUSEKEEPING_STATUS_OPTIONS
} from 'ducks/allocations';
import './styles.css';

const HOUSEKEEPING_SELECTED_VALUE_OPTIONS = {
  [HOUSEKEEPING_STATUS_OPTIONS.CLEAN]: 'Clean',
  [HOUSEKEEPING_STATUS_OPTIONS.DIRTY]: 'Dirty',
  [HOUSEKEEPING_STATUS_OPTIONS.INSPECTED]: 'Inspected',
  [HOUSEKEEPING_STATUS_OPTIONS.OUT_OF_SERVICE]: 'OOS',
  [HOUSEKEEPING_STATUS_OPTIONS.OUT_OF_ORDER]: 'OOO'
};

class HousekeepingSelectedValue extends React.Component<any> {
  render() {
    return (
      <div className="HousekeepingSelectedValue">
        <div
          className="ellipse"
          style={{
            backgroundColor:
              HOUSEKEEPING_STATUS_TO_COLOR_MAPPER[this.props.value.label]
          }}
        />
        <div className="HousekeepingSelectedValue__label">
          {HOUSEKEEPING_SELECTED_VALUE_OPTIONS[this.props.value.label]}
        </div>
      </div>
    );
  }
}

export default HousekeepingSelectedValue;
